<div class="flex flex-col md:gap-2 h-full" *transloco="let t">
  <div
    class="flex-0 flex flex-col md:flex-row justify-start md:justify-between gap-2 lg:gap-y-2 md:items-center sticky top-0 min-h-10 border-b-1 border-solid border-gray-200 p-2 z-50 bg-white md:-mx-8"
  >
    <img
      ngSrc="/assets/img/orlen_skylight.svg"
      alt="Orlen Skylight Logo"
      width="416"
      height="92"
      priority
      class="w-auto object-contain max-h-[40px]"
    />

    <div class="flex flex-wrap items-center gap-2 justify-end">
      <mat-form-field appearance="outline">
        <mat-select [formControl]="language" panelClass="custom-multi-select">
          <mat-select-trigger>
            <div class="flex gap-2 items-center">
              @let flag = getFlagByValue(langValue);
              @if (flag) {
                <img [ngSrc]="flag" alt="flag {{ langValue }}" width="15" height="10" />
              }
              <span>{{ t('languages.' + langValue) }}</span>
            </div>
          </mat-select-trigger>
          @for (lang of languages(); track $index) {
            <mat-option [value]="lang.value">
              <div class="flex gap-2">
                @if (lang.flag) {
                  <img [ngSrc]="lang.flag" alt="flag {{ lang.value }}" width="15" height="10" />
                }
                <span>{{ t('languages.' + lang.value) }}</span>
              </div>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (moreActions()) {
        <div class="flex flex-row items-center">
          <ng-container [ngTemplateOutlet]="moreActions()"></ng-container>
        </div>
      }
    </div>
  </div>

  <ng-content></ng-content>

  @if (version()) {
    <div class="flex justify-center mb-1">
      <span class="palette-text-64 text-sm max-w-[1152px] basis-full flex-grow flex-shrink text-right">
        {{ version() }}
      </span>
    </div>
  }
</div>
